/*
 * Pagina del Dashboard: Permite navegar dentro de la aplicacion
 * Muestra la barra de navegacion, el acceso al perfil y renderiza el modulo y proceso seleccionado
 */

import {
  Dashboard,
  DashboardMain,
  MenuWrapper,
  MenuItems,
  HeaderBoxLeft,
  HeaderBoxRight,
  HeaderWrapper,
  HeaderSearch,
  HeaderUser,
  HeaderUserItem,
  Divider,
  FloatingToolbox,
  shootToast,
  Agentflo,
  Button,
} from "codekit";

import DashboardChildRoute from "./DashboardChildRoute";
import MyProfile from "./MyProfile";

import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  getDataUser,
  getMenuUser,
  signOut,
  setMenuUser,
  setModuleURL,
  getIsReplaceUser,
  getInfoUserReplace,
  getInfoUser,
  getIsOtherUser,
  getPreviewInfoUser,
  setReturnUser,
  getSecuenceHistory,
} from "../libs/redux/slices/authSlice/authSlice";
import {
  getModuleSelected,
  getProcesSelected,
  reset,
  setModuleSelected,
  setProcesSelected,
} from "../libs/redux/slices/MenuSlice/menuSlice";
import { useLogoutMutation } from "../libs/redux/slices/authSlice/authApiSlice";
import { useOrderMenuMutation } from "../libs/redux/slices/MenuSlice/menuApliSlice";
import { resetFiltersGraph } from "../libs/redux/slices/Graficsx/graficsxSlice";

import capitalizeWord from "../utils/capitalize-words";
import generateAvatarLetters from "../utils/avatar-letters-generator";
import { resetConsult } from "../libs/redux/slices/consultSlice/consultSlice";
import { resetCustomFilters } from "../libs/redux/slices/trackingSlice/trackingSlice";
import { Notificx } from "./Notificx";
import Chatboxx from "../components/Agentexx/Chatboxx";
import Usertmpx from "./Usertmpx";
import Vercomo from "../components/Usuarios/Vercomo/Vercomo";
import Vercomob from "../components/Usuarios/Vercomo/Vercomob";
import Entrarcu from "../components/Usuarios/Entrarcu/Entrarcu";
import Entrarcub from "../components/Usuarios/Entrarcu/Entrarcub";
import { useReturnUserMutation, useDeleteHistoryMutation } from "../libs/redux/slices/AdminxxxSlice/adminxxxApiSlice";

import Causapay from "../components/Modimpxx/Testimpx/Causapay/Causapay";
import Delcfirm from "../components/Confirmx/Delcfirm";
import { useUserAbsentMutation, useGetUserAusentMutation, useGetTurnsTodayByUserQuery, useSetUserAusentMutation } from "../libs/redux/slices/authSlice/authApiSlice";
import Creadoxx from "../components/Modimpxx/Trackimp/Creadoxx/Creadoxx";
import { getCheckedRows } from "../libs/redux/slices/trackingSlice/trackingSlice";
import Userause from "../components/Userause/Userause";
import Trasladv from "../components/Modimpxx/Testimpx/Trasladv";
import Pagocsuc from "../components/Modimpxx/Testimpx/Pagocsuc/Pagocsuc";
import Gestcont from "../components/Modimpxx/Testimpx/Gestcont/Gestcont";
import { useGetCustomsActivityQuery } from "../libs/redux/slices/Modimpxx/Customsai/customsaiApiSlice";
import {
  useLazyGetMipuestoPestanasQuery,
  useAgregarMipuestoPestanaMutation,
  useQuitarMipuestoPestanaMutation,
} from "../libs/redux/slices/Mipuesto/mipuestoApiSlice";

const DashboardPage = () => {
  const dispatch = useDispatch();

  const userData = useSelector(getDataUser);
  const menuData = useSelector(getMenuUser);
  const [getMipuestoPestanas] = useLazyGetMipuestoPestanasQuery();
  const [agregarMipuestoPestana] = useAgregarMipuestoPestanaMutation();
  const [quitarMipuestoPestana] = useQuitarMipuestoPestanaMutation();
  const [mipuestoPestanas, setMipuestoPestanasLocal] = useState([]);
  const [pinConfirm, setPinConfirm] = useState(null);

  const { MODURLXX } = useSelector(getModuleSelected);
  const { PRODURLX } = useSelector(getProcesSelected);
  const { USREMAXX, USRNOMXX, USRIDXXX } = userData;

  const { data: turnsByUser } = useGetTurnsTodayByUserQuery({ USRIDXXX });

  const [orderMenu] = useOrderMenuMutation();
  const [logout] = useLogoutMutation();

  const [menuDataMap, setMenuDataMap] = useState([]);
  const [showMyProfile, setShowMyProfile] = useState(false);
  const [isAusent, setIsAusent] = useState(false);
  const [openModalAusent, setOpenModalAusent] = useState(false);
  const isReplaceUser = useSelector(getIsReplaceUser);
  const [infoUser, setInfoUser] = useState({ USREMAXX, USRNOMXX, USRIDXXX });
  const infoUserReplace = useSelector(getInfoUserReplace);
  const [isCauPay, setIsCauPay] = useState(false);
  const [isNuevoDO, setIsNuevoDO] = useState(false);
  // Asistente: Customs AI notifica al usuario que originó la tarea y el
  // panel se abre solo cuando llega actividad nueva suya.
  const [isAgentOpen, setIsAgentOpen] = useState(false);
  // selectFromResult: SOLO los datos — sin esto, cada ciclo de polling
  // notifica isFetching y re-renderiza el dashboard completo (titileo).
  const { data: dataCustomsMine } = useGetCustomsActivityQuery(
    { mine: true },
    {
      pollingInterval: 20000,
      skip: !USRIDXXX,
      selectFromResult: ({ data }) => ({ data }),
    }
  );
  const customsEvents = dataCustomsMine?.data ?? [];
  useEffect(() => {
    if (customsEvents.length === 0) return;
    // localStorage (no session): una recarga no debe re-abrir por eventos viejos
    const seenKey = `customsai-abiertos-${USRIDXXX || "anon"}`;
    const seen = new Set(JSON.parse(localStorage.getItem(seenKey) ?? "[]"));
    const fresh = customsEvents.filter((e) => e.EVENTOID && !seen.has(e.EVENTOID));
    if (fresh.length > 0) {
      setIsAgentOpen(true);
      fresh.forEach((e) => seen.add(e.EVENTOID));
      localStorage.setItem(seenKey, JSON.stringify([...seen].slice(-300)));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customsEvents]);
  const userInfo = useSelector(getInfoUser);
  const isOtherUser = useSelector(getIsOtherUser);
  const previewUserData = useSelector(getPreviewInfoUser);
  const [returnUserMutation] = useReturnUserMutation();
  const [deleteHistory] = useDeleteHistoryMutation();
  const [userAbsent] = useUserAbsentMutation();
  const [getUserAusent] = useGetUserAusentMutation();
  const [setUserAusent] = useSetUserAusentMutation();
  const SECINGID = useSelector(getSecuenceHistory);
  const selectedRows = useSelector(getCheckedRows);
  const [isTraslado, setIsTraslado] = useState(false);
  const [isCauPayBranch, setIsCauPayBranch] = useState(false);
  const [isGestcont, setIsGestcont] = useState(false);

  const toDateAt = (dateStr, timeStr) => new Date(`${dateStr}T${timeStr}`);

  // Verificamos el permiso del boton pago causaciones
  const bPermCau = userData?.USERPERM?.some((userPerm) => {
    if (userPerm.MODIDXXX === 117) {
      return userPerm?.CIMS0004?.some((cims0004) => {
        if (cims0004.PROIDXXX === 101) {
          return cims0004?.CIMS0005?.some((cims0005) => cims0005.MENIDXXX === 103);
        }
        return false;
      });
    }
    return false;
  });

  // Verificamos el permiso del boton nuevo DO
  const bPermNuevoDO = userData?.USERPERM?.some((userPerm) => {
    if (userPerm.MODIDXXX === 117) {
      return userPerm?.CIMS0004?.some((cims0004) => {
        if (cims0004.PROIDXXX === 100) {
          return cims0004?.CIMS0005?.some((cims0005) => cims0005.MENIDXXX === 100);
        }
        return false;
      });
    }
    return false;
  });

  // Verificamos el permiso del boton traslado anticipos
  const aplyTraslado = userData?.USERPERM?.some((userPerm) => {
    if (userPerm.MODIDXXX === 117) {
      return userPerm?.CIMS0004?.some((cims0004) => {
        if (cims0004.PROIDXXX === 101) {
          return cims0004?.CIMS0005?.some((cims0005) => cims0005.MENIDXXX === 107);
        }
        return false;
      });
    }
    return false;
  });

  // Verificamos el permiso del boton pago causaciones sucursales
  const applyCasuPayBranch = userData?.USERPERM?.some((userPerm) => {
    if (userPerm.MODIDXXX === 117) {
      return userPerm?.CIMS0004?.some((cims0004) => {
        if (cims0004.PROIDXXX === 101) {
          return cims0004?.CIMS0005?.some((cims0005) => cims0005.MENIDXXX === 108);
        }
        return false;
      });
    }
    return false;
  });

  // Verificamos el permiso del boton tarea gestion contable
  const applyGestcont = userData?.USERPERM?.some((userPerm) => {
    if (userPerm.MODIDXXX === 117) {
      return userPerm?.CIMS0004?.some((cims0004) => {
        if (cims0004.PROIDXXX === 101) {
          return cims0004?.CIMS0005?.some((cims0005) => cims0005.MENIDXXX === 109);
        }
        return false;
      });
    }
    return false;
  });

  const toggleAusent = async () => {
    try {
      const response = await getUserAusent(USRIDXXX).unwrap();
      if (!response.data.ausente) {
        console.log("El usuario ya está marcado como ausente.");
        setOpenModalAusent(true);
      } else {
        await userAbsent({ 'USRIDXXX': USRIDXXX }).unwrap();
        setIsAusent((prev) => !prev);
      }
    } catch (error) {
      console.error("Error al cambiar el estado de ausencia:", error);
    }
  };

  const toggleTurns = async () => {
    try {
      const dayData = turnsByUser?.data;
      const turns = dayData?.TURNSXXX ?? [];

      if (!Array.isArray(turns) || turns.length === 0) {
        shootToast({
          variant: 'error',
          text: 'No Tiene Ningún Turno Asignado',
          duration: 5000,
        });
        return;
      }

      const dateStr = dayData.DATEXXXX;

      const ranges = turns
        .flatMap(t =>
          (t.RANGESXX ?? []).map(r => ({
            start: toDateAt(dateStr, r.STARTXXX),
            end:   toDateAt(dateStr, r.ENDXXXXX),
          }))
        )
        .sort((a, b) => a.start - b.start);

      if (ranges.length === 0) {
        shootToast({
          variant: 'error',
          text: 'No Tiene Ningún Turno Asignado',
          duration: 5000,
        });
        return;
      }

      const now = new Date();

      const current = ranges.find(r => now >= r.start && now < r.end);
      if (current) {
        shootToast({
          variant: 'error',
          text: 'Su Turno Aun Sigue Activo, Por Favor Ciérrelo Cuando Sea Oportuno',
          duration: 5000,
        });
        return;
      }

      const lastRange = ranges[ranges.length - 1];

      if (now >= lastRange.end) {
        await setUserAusent(USRIDXXX).unwrap();
        return;
      }
      shootToast({
        variant: 'error',
        text: 'Su Turno Aun Sigue Activo, Por Favor Ciérrelo Cuando Sea Oportuno',
        duration: 5000,
      });
    } catch (error) {
      console.error('Error al validar el turno:', error);
      shootToast({
        variant: 'error',
        text: 'Ocurrió un error al validar su turno. Intente nuevamente.',
        duration: 5000,
      });
    }
  };


  /**
   * Hook que establece los elementos del menu de navegacion y actualiza su estado activo cuando se seleccionan
   */
  useEffect(() => {
    /**
     * Funcion para guardar el modulo y proceso elegido del menu de navgacion
     */
    const onSelectOption = (moduleItem, processItem) => {
      dispatch(setModuleSelected(moduleItem));
      dispatch(setProcesSelected(processItem));
      setShowMyProfile(false);
    };

    /**
     * Funcion que genera los items del menu de navegacion
     */
    const menuDataMapper = () => {
      return menuData.map((menu) => {
        let isActive = false;

        if (MODURLXX) {
          isActive = menu.MODURLXX === MODURLXX ? true : false;
        }

        const menuDataItem = {
          id: menu.MODIDXXX,
          description: menu.MODDESXX,
          url: menu.MODURLXX,
          icon: `${menu.MODICOXX}`,
          isActive: isActive,
          items: menu.CIMS0004.map((subItem) => ({
            id: subItem.PROIDXXX,
            description: subItem.PRODESXX,
            url: subItem.PRODURLX,
            onClick: () => {
              onSelectOption(menu, subItem);
            },
          })),
        };
        return menuDataItem;
      });
    };

    const menuDataMap = menuDataMapper();

    setMenuDataMap(menuDataMap);
  }, [MODURLXX, menuData, dispatch]);

  /**
   * Hook que setea la URL del modulo para la cabecera de la peticion
   */
  useEffect(() => {
    if (MODURLXX) {
      dispatch(setModuleURL(MODURLXX.toLowerCase()));
    }
  }, [MODURLXX, dispatch]);

  /**
   * Hook de aterrizaje post-login: si el usuario tiene Mi Puesto de Trabajo
   * parametrizado para su cargo, entra directo al puesto (una sola vez por
   * sesion de pestaña del navegador; sin puesto queda en el home normal)
   */
  useEffect(() => {
    const handleAterrizajeMipuesto = async () => {
      const menuMipuesto = menuData.find((menu) => menu.MODURLXX === "Mipuesto");
      const processMipuesto = menuMipuesto?.CIMS0004?.find((process) => process.PRODURLX === "Mipuesto");
      if (!menuMipuesto || !processMipuesto) {
        return;
      }
      sessionStorage.setItem("mipuestoAterrizado", "1");
      await getMipuestoPestanas()
        .unwrap()
        .then((response) => {
          if ((response?.data?.pestanas ?? []).length > 0) {
            dispatch(setModuleSelected(menuMipuesto));
            dispatch(setProcesSelected(processMipuesto));
          }
        })
        .catch(() => {});
    };
    if (menuData?.length > 0 && !sessionStorage.getItem("mipuestoAterrizado")) {
      handleAterrizajeMipuesto();
    }
  }, [menuData, dispatch, getMipuestoPestanas]);

  /**
   * Hook que carga las pestañas del puesto para pintar el estado del pin
   * (circle-check) en los submenús del menú lateral
   */
  useEffect(() => {
    const handleLoadPestanas = async () => {
      await getMipuestoPestanas()
        .unwrap()
        .then((response) => setMipuestoPestanasLocal(response?.data?.pestanas ?? []))
        .catch(() => {});
    };
    if (menuData?.length > 0) {
      handleLoadPestanas();
    }
  }, [menuData, getMipuestoPestanas]);

  //Llaves modulo-proceso de las pestañas del puesto (estado del pin del menú)
  const pinnedSubitems = mipuestoPestanas
    .filter((tab) => tab.MODIDXXX)
    .map((tab) => `${tab.MODIDXXX}-${tab.PROIDXXX}`);

  //Ejecuta el pin (agregar o quitar) contra el backend y refresca el estado
  const executePinSubitem = async (menuItem, subItem, isPinned) => {
    const mutation = isPinned ? quitarMipuestoPestana : agregarMipuestoPestana;
    await mutation({ MODIDXXX: menuItem.id, PROIDXXX: subItem.id })
      .unwrap()
      .then((response) => {
        setMipuestoPestanasLocal(response?.data ?? []);
        shootToast({
          variant: "success",
          text: isPinned
            ? `${subItem.description} quitado de Mi Puesto de Trabajo`
            : `${subItem.description} agregado a Mi Puesto de Trabajo`,
          duration: 3000,
        });
      })
      .catch(() => {
        shootToast({ variant: "error", text: "No se pudo actualizar Mi Puesto de Trabajo", duration: 3000 });
      });
  };

  //Toggle del pin: agregar pide confirmación (evita inclusiones por error)
  const handlePinSubitem = (menuItem, subItem, isPinned) => {
    if (isPinned) {
      executePinSubitem(menuItem, subItem, true);
      return;
    }
    setPinConfirm({
      menuItem,
      subItem,
      text: `¿Agregar "${subItem.description}" a Mi Puesto de Trabajo?`,
    });
  };

  /**
   * Funcion para cerrar sesion del usuario
   */
  const onLogout = async () => {
    if (isOtherUser) {
      await deleteHistory(SECINGID);
    }
    sessionStorage.removeItem("mipuestoAterrizado");
    await logout();
    dispatch(signOut());
    dispatch(reset());
    dispatch(resetConsult());
    dispatch(resetCustomFilters());
    dispatch(resetFiltersGraph());
  };

  /**
   * Funcion que vacia el modulo y proceso elegido
   */
  const handleClickHome = () => {
    dispatch(setModuleSelected(""));
    dispatch(setProcesSelected(""));
    setShowMyProfile(false);
  };

  //Regreso al puesto de trabajo desde el boton flotante
  const handleVolverMipuesto = () => {
    const menuMipuesto = menuData.find((menu) => menu.MODURLXX === "Mipuesto");
    const processMipuesto = menuMipuesto?.CIMS0004?.find((process) => process.PRODURLX === "Mipuesto");
    if (menuMipuesto && processMipuesto) {
      dispatch(setModuleSelected(menuMipuesto));
      dispatch(setProcesSelected(processMipuesto));
    }
  };

  /**
   * Funcion para reordenar los elementos del menu
   */
  const reorderMenuData = (context) => {
    const indexes = context.item.indexes;
    const newIndex = indexes.new;
    const previousIndex = indexes.previous;

    const newMenuData = [...menuData];
    const [removed] = newMenuData.splice(previousIndex, 1);
    newMenuData.splice(newIndex, 0, removed);
    return newMenuData;
  };

  /**
   * Funcion que sirve para guardar el nuevo orden del menu
   */
  const setNewMenuOrder = async (newDataMenu) => {
    const data = newDataMenu.map((module) => {
      return module.MODIDXXX;
    });
    await orderMenu({ MODIDXXX: data }).unwrap();
  };

  /**
   * Funcion que maneja el arrastrado de los items del menu
   */
  const handleMenuDragging = (context) => {
    // Set new menuDataMap order
    const items = context._newItems;
    setMenuDataMap(items);

    // Set new menuData order
    const newMenuData = reorderMenuData(context);
    dispatch(setMenuUser(newMenuData));
    setNewMenuOrder(newMenuData);
  };

  const returnUser = async () => {
    let userData = { ...previewUserData };
    let { token: TOKENXXX } = userData.data[0];

    await returnUserMutation({ SECINGID: SECINGID, body: { TOKENXXX: TOKENXXX } })
      .unwrap()
      .then(() => {
        dispatch(setReturnUser({ userData }));
        handleClickHome();
      })
      .catch();
  };

  //Hook que controla el cambio de informacion para el usuario reemplazo
  useEffect(() => {
    if (Object.entries(infoUserReplace).length > 0) {
      setInfoUser({ ...infoUserReplace });
    }
  }, [infoUserReplace]);

  useEffect(() => {
    if (Object.entries(userInfo).length > 0 && !isReplaceUser) {
      setInfoUser({ ...userInfo });
    }
  }, [userInfo, isReplaceUser]);

  //Funcion para validar la creacion de un nuevo DO
  const handleOpenNuevoDO = () => {

    const isDoctraxx = MODURLXX === "Doctraxx";
    const rowsCount = selectedRows.length;

    if (rowsCount === 0) {
      if ((isDoctraxx && PRODURLX === "Saldoctr") || (MODURLXX === "Faccomxx" && PRODURLX === "Salfactx")) {
        shootToast({
          variant: 'warning',
          text: `Debe seleccionar un ${isDoctraxx ? 'Documento de Transporte' : 'Saldo de Documentos'} para crear uno nuevo.`,
          duration: 5000,
        });
        return;
      }
      setIsNuevoDO(true);
      return;
    }

    const allWithSaldo = selectedRows.every(row => row.SAFAESTX === "CON SALDO" || row.DOCTRAES === "CON SALDO");
    if (!allWithSaldo) {
      shootToast({
        variant: 'error',
        text: 'No es posible crear el DO, el estado no se encuentra con saldo.',
        duration: 5000,
      });
      return;
    }

    if (isDoctraxx) {
      if (rowsCount > 1) {
        const firstDtrcnico = selectedRows[0].DTRCNICO;
        const allSameDtrcnico = selectedRows.every(row => row.DTRCNICO === firstDtrcnico);

        if (!allSameDtrcnico) {
          shootToast({
            variant: 'warning',
            text: 'Los Documentos de transporte deben contar con el mismo Cliente, por favor valide.',
            duration: 5000,
          });
          return;
        }

        const areAllZonaFranca = selectedRows.every(row =>
          row.DEPDESXX && row.DEPDESXX.toLowerCase().includes("zona franca")
        );

        if (!areAllZonaFranca) {
          shootToast({
            variant: 'warning',
            text: 'Solo puede seleccionar un Documento de Transporte si el depósito no es Zona Franca.',
            duration: 5000,
          });
          return;
        }
        if (areAllZonaFranca) {
          const firstDepId = selectedRows[0].DEPIDXXX;
          const allSameDepId = selectedRows.every(row => row.DEPIDXXX === firstDepId);

          if (!allSameDepId) {
            shootToast({
              variant: 'warning',
              text: 'Los Documentos de transporte no cuentan con el mismo Depósito por favor valide.',
              duration: 5000,
            });
            return;
          }
        }
      }
      const firstClientId = selectedRows[0].CLIIDXXX;
      const allSameClient = selectedRows.every(row => row.CLIIDXXX === firstClientId);

      if (allSameClient) {
        setIsNuevoDO(true);
      } else {
        shootToast({
          variant: 'warning',
          text: 'Debe seleccionar Saldos de Documentos de un mismo cliente.',
          duration: 5000,
        });
      }
      return;
    }

    if (rowsCount > 0) {
      const firstClientId = selectedRows[0].CLIIDXXX;
      const allSameClient = selectedRows.every(row => row.CLIIDXXX === firstClientId);

      if (allSameClient) {
        setIsNuevoDO(true);
      } else {
        shootToast({
          variant: 'warning',
          text: 'Debe seleccionar Saldos de Documentos de un mismo cliente.',
          duration: 5000,
        });
      }
    }
  };

  return (
    <Dashboard>
      <HeaderWrapper>
        <HeaderBoxLeft>
          <HeaderSearch />
        </HeaderBoxLeft>
        <HeaderBoxRight>
          <Notificx isAusent={isAusent} />
          <Agentflo open={isAgentOpen} onOpenChange={setIsAgentOpen}>
            <Chatboxx customsEvents={customsEvents} />
          </Agentflo>
          <FloatingToolbox
            initialPosition={{ x: 630, y: 20 }}
            persistKey="dashboard-floating-toolbox-position"
            buttons={[
              // Si bPermNuevoDO es true, mostramos el botón
              bPermNuevoDO && {
                icon: "plus",
                tooltip: "Crear Nuevo DO",
                variant: "primary",
                onClick: () => {
                  handleOpenNuevoDO()
                },
              },
              // Si bPermCau es true, mostramos el botón
              bPermCau && {
                icon: "coin",
                tooltip: "Solicitar Pago Causaciones",
                variant: "secondary",
                onClick: () => {
                  setIsCauPay(true);
                },
              },
              aplyTraslado && {
                icon: "financing-config",
                tooltip: "Solicitud de Traslado",
                variant: "secondary",
                onClick: () => {
                  setIsTraslado(true);
                },
              },
              applyCasuPayBranch && {
                icon: "file-money",
                tooltip: "Solicitar Pago Causaciones Sucursales",
                variant: "secondary",
                onClick: () => {
                  setIsCauPayBranch(true);
                },
              },
              applyGestcont && {
                icon: "financing-config",
                tooltip: "Gestión Contable",
                variant: "secondary",
                onClick: () => {
                  setIsGestcont(true);
                },
              },
            ].filter(Boolean)} // Usamos .filter(Boolean) para eliminar valores null
          />
          {isCauPay && <Causapay setIsCauPay={setIsCauPay} />}
          {pinConfirm && (
            <Delcfirm
              actionElement={{ text: pinConfirm.text }}
              acceptLabel="Agregar"
              handleConfirmAction={(confirm) => {
                if (confirm) {
                  executePinSubitem(pinConfirm.menuItem, pinConfirm.subItem, false);
                }
                setPinConfirm(null);
              }}
            />
          )}
          {mipuestoPestanas.length > 0 && MODURLXX !== "" && MODURLXX !== "Mipuesto" && (
            <div style={{ position: "fixed", bottom: 24, right: 24, zIndex: 40 }}>
              <Button variant="primary-bold" size="m" icon="arrow-left" onClick={handleVolverMipuesto}>
                Mi Puesto de Trabajo
              </Button>
            </div>
          )}
          {isNuevoDO && <Creadoxx handleClose={() => setIsNuevoDO(false)} row={selectedRows} setShowCreateDo={setIsNuevoDO} modurlxx={MODURLXX} isFromToolbox />}
          {isTraslado && <Trasladv setTraslant={setIsTraslado} />}
          {isCauPayBranch && <Pagocsuc setIsCauPayBranch={setIsCauPayBranch} />}
          {isGestcont && <Gestcont setGestcont={setIsGestcont} />}

          <HeaderUser
            image={`${infoUser.USRURLFO && infoUser.USRURLFO !== ""
              ? infoUser?.USRURLFO
              : generateAvatarLetters(`${infoUser.USRNOMXX}`)
              }`}
            name={capitalizeWord(infoUser.USRNOMXX)}
            email={infoUser.USREMAXX.toLowerCase()}
            isReplace={isReplaceUser}
            isAusent={isAusent}
          >
            <HeaderUserItem icon="user-inactive" onClick={toggleTurns}>
              Cerrar Turno
            </HeaderUserItem>
            {!isOtherUser ? (
              <HeaderUserItem icon="user" onClick={() => setShowMyProfile(true)}>
                Mi Perfil
              </HeaderUserItem>
            ) : (
              <HeaderUserItem icon="user-change" onClick={() => returnUser()}>
                Volver a Mi Perfil
              </HeaderUserItem>
            )}
            <Usertmpx handleClickHome={handleClickHome} />
          <Vercomo />
          <Entrarcu />
            <HeaderUserItem icon="user-inactive" onClick={toggleAusent}>
              Activar / Inactivar Ausente
            </HeaderUserItem>
            <Divider />
            <HeaderUserItem icon="logout" onClick={onLogout}>
              Cerrar sesión
            </HeaderUserItem>
          </HeaderUser>
        </HeaderBoxRight>
      </HeaderWrapper>
      <MenuWrapper>
        <HeaderUser
          image={`${infoUser.USRURLFO && infoUser.USRURLFO !== ""
            ? infoUser?.USRURLFO
            : generateAvatarLetters(`${infoUser.USRNOMXX}`)
            }`}
          name={capitalizeWord(infoUser.USRNOMXX)}
          email={infoUser.USREMAXX.toLowerCase()}
          isInsideMenu
          isReplace={isReplaceUser}
        >
          <HeaderUserItem icon="user-inactive" onClick={toggleTurns}>
            Cerrar Turno
          </HeaderUserItem>
          <HeaderUserItem icon="user" onClick={() => setShowMyProfile(true)}>
            Mi Perfil
          </HeaderUserItem>
          <Usertmpx handleClickHome={handleClickHome} />
          <Vercomo />
          <Entrarcu />
          <HeaderUserItem icon="user-inactive" onClick={toggleAusent}>
            Activar / Inactivar Ausente
          </HeaderUserItem>
          <HeaderUserItem icon="logout" onClick={onLogout}>
            Cerrar sesión
          </HeaderUserItem>
        </HeaderUser>
        <MenuItems
          labelHome="Inicio"
          onClickHome={handleClickHome}
          onMenuDragged={handleMenuDragging}
          pinnedSubitems={pinnedSubitems}
          onPinSubitem={handlePinSubitem}
          items={menuDataMap.filter((menu) => menu.url !== "Mipuesto")}
          fixedItem={menuDataMap.find((menu) => menu.url === "Mipuesto")}
        />
      </MenuWrapper>
      <DashboardMain>
        <Vercomob handleClickHome={handleClickHome} />
        <Entrarcub handleClickHome={handleClickHome} onVolver={returnUser} />
        {showMyProfile ? <MyProfile handleClickHome={handleClickHome} /> : <DashboardChildRoute />}
        {openModalAusent && <Userause infoUser={infoUser} setOpenModalAusent={setOpenModalAusent} setIsAusent={setIsAusent} />}
      </DashboardMain>
    </Dashboard>
  );
};

export default DashboardPage;
